/**
 * Keyboard Shortcut Module Configuration
 */

export const KEYBOARD_SHORTCUT_CONFIG = {
  MODULE_NAME: 'Keyboard Shortcuts',
  MODULE_PATH: 'keyboard-shortcut',
  STORAGE_KEY: 'user_keyboard_shortcuts',

  // Categories for filtering
  CATEGORIES: [
    { value: 'all', label: 'All' },
    { value: 'navigation', label: 'Navigation' },
    { value: 'actions', label: 'Actions' },
    { value: 'general', label: 'General' },
  ],
};

export default KEYBOARD_SHORTCUT_CONFIG;
